export default __webpack_public_path__ + "static/media/de.e5a3ef3d.svg";